
import DespatchAPIService from '@/modules/despatch/services/apiService'

export default class DespatchModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.despatchService = new DespatchAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
    ]
  }
}
